export default "__VITE_ASSET__eaf1c713__"